module.exports = __webpack_public_path__ + "static/media/laboratorio.2e0cc707.png";